import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { ImportOutlined, PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row } from 'antd';
import { Link, Route, Routes } from 'react-router-dom';
import DeleteModal from 'components/deleteModalView';
import { useTranslation } from 'react-i18next';
import useCalendarCategories from '../useCalendarCategories';

const MainPage = () => {
  const {
    data,
    columns,
    onChangeTableFilter,
    loading,
    onDelete,
    updateInProcess,
  } = useCalendarCategories();
  const { t } = useTranslation();

  return (
    <>
      <PageHeader title={t('TRADING CALENDAR').toUpperCase()}>
        <Row gutter={16}>
          <Col>
            <Link to={'import '}>
              <Button
                icon={<ImportOutlined />}
                big
                type={'green'}
                width={'138px'}
              >
                {t('IMPORT')}
              </Button>
            </Link>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Table
          loading={loading}
          columns={columns}
          dataSource={data.calendar_categories}
          pagination={data.pagination}
          onChange={onChangeTableFilter}
        />
      </div>
      <Routes>
        <Route
          path={':id/delete'}
          element={
            <DeleteModal loading={updateInProcess} onClickDelete={onDelete} />
          }
        />
      </Routes>
    </>
  );
};

export default MainPage;
